import { type HTMLAttributes } from 'react';
import { cn } from './cn';

export type PillTone = 'neutral' | 'accent' | 'green' | 'red' | 'blue' | 'ink';

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: PillTone;
}

const TONE_CLASSES: Record<PillTone, string> = {
  neutral: 'bg-paper-2 text-ink border-line',
  accent: 'bg-[#FEF3C7] text-[#92400E] border-[#FCD34D]',
  green: 'bg-[#D1FAE5] text-[#065F46] border-[#6EE7B7]',
  red: 'bg-[#FEE2E2] text-[#991B1B] border-[#FCA5A5]',
  blue: 'bg-[#DBEAFE] text-[#1E3A8A] border-[#93C5FD]',
  ink: 'bg-ink text-paper border-ink-2',
};

export function Pill({ tone = 'neutral', className, children, ...rest }: PillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 text-xs font-medium rounded-pill border',
        TONE_CLASSES[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
